export function IsSuccessCode(response: Response | null) {
  if (!response?.status) {
      return false;
  }
return response.status >= 200 && response.status <= 299;
}